module.exports = __webpack_public_path__ + "img/xentral-logo-illustrated.bdcc07cb.svg";